import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createRavenMiddleware from 'raven/middleware';
import { appendLoggerMiddlewareInDev } from 'utils/redux';

const sagaMiddleware = createSagaMiddleware();
const ravenMiddleware = createRavenMiddleware();

export default function configureStore(
  rootReducer,
  rootSaga,
  otherMiddlewares = []
) {
  const middlewares = [sagaMiddleware, ...otherMiddlewares, ravenMiddleware];

  appendLoggerMiddlewareInDev(middlewares);

  const enhancers = [applyMiddleware(...middlewares)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;

  const store = createStore(rootReducer, composeEnhancers(...enhancers));
  sagaMiddleware.run(rootSaga);

  return store;
}



// WEBPACK FOOTER //
// ./src/utils/redux/configureStore.js